'use client'

import * as React from 'react'
import { createIcon } from '../utils'

const DeleteIcon = createIcon({
    displayName: 'DeleteIcon',
    viewBox: '0 0 16 16',
    fill: 'none',
    path: (
        <path
            d="M6.067 2.4h4m-8 2h12m-1.334 0l-.467 7.013c-.07 1.052-.105 1.578-.333 1.977a2 2 0 01-.865.81c-.413.2-.94.2-1.995.2H7.06c-1.054 0-1.581 0-1.994-.2a2 2 0 01-.866-.81c-.227-.399-.262-.925-.332-1.977L3.4 4.4m3.333 3v3.333M9.4 7.4v3.333"
            stroke="currentColor"
            strokeWidth={1.2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    ),
})

export default DeleteIcon
